var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pre',{directives:[{name:"highlight",rawName:"v-highlight",value:(_vm.data.content),expression:"data.content"}]},[_vm._v("  "),_c('code',{class:[_vm.data.codeFormat]}),_vm._v("\n")])}
var staticRenderFns = []

export { render, staticRenderFns }